export enum MarkerType {
  tourStart = 'tourStart',
  tourFinish = 'tourFinish',
  customer = 'customer',
  finishedDelivery = 'finishedDelivery',
  primaryLocation = 'primaryLocation',
  ghostLocation = 'ghostLocation',
  planned = 'planned',
}
